import { render, staticRenderFns } from "./onlineProductTiktok.vue?vue&type=template&id=2f143286&scoped=true"
import script from "./onlineProductTiktok.vue?vue&type=script&lang=js"
export * from "./onlineProductTiktok.vue?vue&type=script&lang=js"
import style0 from "./onlineProductTiktok.vue?vue&type=style&index=0&id=2f143286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f143286",
  null
  
)

export default component.exports